import React from 'react';
import { Table } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

var moment = require('moment');


class SyncMessage extends React.Component {
  constructor (props) {
    super(props)
    this.sync = this.sync.bind(this);
  }

  sync(){
      this.props.syncWarehouses('');
  };

  render() {
    const {date} =this.props;
     let syncDate = moment(date, moment.ISO_8601);
    if ( syncDate.isBefore(moment().startOf('day'))){
      return (  <Button
          bsSize="xsmall"
          variant="primary"
          onClick={this.sync}>Update
        </Button>  )
    }else{
      return (<div className="green"><b>:-)</b></div>)
    }
  }
}


class InvoiceMessage extends React.Component {

  render() {
    const {entries,autoreconcile , warehouseId} =this.props;
    if ( entries > 0 ){
      return ( <div><div><b>Some reconcilliation to do</b></div>
      <div><Button
          bsSize="xsmall"
          variant="primary"
          onClick={autoreconcile}>Auto Reconcile
        </Button></div>
        <div><Button
            bsSize="xsmall"
            variant="primary"
            href={'/view/' + warehouseId + '/reconcile'}
            >Manual Reconcile
          </Button></div>
      </div>
      )
    }else{
      return (<div className="green"><b>:-)</b></div>)
    }
  }
}

class NotSetInvoiceMessage extends React.Component {

  render() {
    const {entries} =this.props;
    if ( entries > 0 ){
      return ( <div className="red"><b>Need to add warehouse</b></div>
      )
    }else{
      return (<div className="green"><b>:-)</b></div>)
    }
  }
}

class Status extends React.Component {
  constructor (props) {
    super(props)
    this.autoreconcile = this.autoreconcile.bind(this);
  }

  autoreconcile(){
      this.props.reconcileMatches('Foulger');
  };


  render() {
    const { warehousedashboard } = this.props;
    if(  warehousedashboard.isFetching ){
      return (
        <Card header="Status">
            <div className="loader">Loading...</div>
          </Card>)
    }else{
      return (

        <Card header="Status">
        <Table >
          <thead>
            <tr className="profit-head">
            <th className="inv-head-med">Last Sync</th>
            <th className="inv-head-med">Invoices with no warehouse</th>
            </tr>
          </thead>
          <tbody>
          <tr className="summary-row">
            <td className="inv-head-med">{moment(warehousedashboard.dashboard.lastSynchronized, moment.ISO_8601).format('DD-MM-YYYY@HH:mm')}</td>
            <td className="inv-head-med">{warehousedashboard.dashboard.missingWarehouseInvoices}</td>

            </tr>
            <tr><td><SyncMessage date={warehousedashboard.dashboard.lastSynchronized} syncWarehouses={this.props.syncWarehouses} /></td>
              <td><NotSetInvoiceMessage entries={warehousedashboard.dashboard.missingWarehouseInvoices} /></td>
          </tr>
          </tbody>
        </Table>
      </Card>
      )
    }
  }
}
export default Status;
